import { EXPERTISE } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const Expertise = () => (
  <section
    id="ekspertise"
    data-testid="expertise-section"
    className="bg-[#f4f4f2] text-[#141414] py-28 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-24">
        <Reveal className="lg:col-span-5">
          <p className="font-ui text-[11px] uppercase tracking-[0.3em] text-[#1f3d2b] mb-6 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-[#1f3d2b]" />
            Ekspertise
          </p>
          <h2 className="font-display font-light leading-[1.05] text-4xl md:text-5xl lg:text-6xl">
            Otte discipliner, ét sammenhængende commerce-setup.
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-6 lg:col-start-7 self-end" delay={0.1}>
          <p className="font-ui text-base md:text-lg text-[#5a5a56] leading-relaxed">
            Fra teknisk fundament til kommerciel eksekvering. Jeg dækker hele
            værdikæden i moderne e-commerce — og binder teknologi, data og
            forretning sammen til én skalerbar motor for vækst.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 border-t border-[#141414]/10">
        {EXPERTISE.map((item, i) => (
          <Reveal
            key={item.id}
            delay={(i % 2) * 0.08}
            className="group border-b border-[#141414]/10 md:odd:border-r md:odd:pr-10 md:even:pl-10"
          >
            <div
              data-testid="expertise-item"
              className="py-10 transition-transform duration-500 group-hover:translate-x-1"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-ui text-xs text-[#1f3d2b] tracking-widest">
                  {item.id}
                </span>
                <h3 className="font-display text-2xl md:text-3xl text-[#141414] group-hover:text-[#1f3d2b] transition-colors duration-300">
                  {item.title}
                </h3>
              </div>
              <p className="mt-4 md:pl-12 font-ui text-sm md:text-base text-[#5a5a56] leading-relaxed max-w-md">
                {item.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
